import React, {useEffect, useState} from "react";
import {SelectOption, UpdateStatusRequest} from "../api/ApiTypes.ts";
import {SamSelect} from "./SamSelect.tsx";
import SamButton from "./SamButton.tsx";
import {useConstantsApi, useOrderApi} from "../context/ApiContext.tsx";
import CancelButton from "./CancelButton.tsx";

interface UpdateStatusAsMessageProps {
    orderId: number,
    onSuccess: () => void;
    onCancel: () => void;
}

export const UpdateStatusAsMessageForm: React.FC<UpdateStatusAsMessageProps> = ({
                                                                orderId,
                                                                onSuccess,
                                                                onCancel
}) => {

    const [statuses, setStatuses] = useState<SelectOption[]>([]);
    const orderApi = useOrderApi();
    const constantsApi = useConstantsApi();

    const defaultState: UpdateStatusRequest = {
        orderId: orderId,
        statusDescription: "",
        message: ""
    };
    const [ formData, setFormData ] = useState<UpdateStatusRequest>(defaultState)

    useEffect(() => {

        constantsApi.getStatusesForUpdateStatus()
            .then(setStatuses)

    }, []);

    const handleSubmit = () => {

        orderApi.updateStatus(formData).then(_ => {
            onSuccess();
        }).catch(console.log);
    };

    const handleCancel = () => {

        setFormData(defaultState);
        onCancel();
    }

    const handleStatusChange = (e: string) => {

        setFormData(prevState => ({
            ...prevState,
            statusDescription: e
        }))
    };

    return (
        <form onSubmit={handleSubmit} className="space-y-4">
            <div className="col-span-1">
                <label htmlFor="statusId" className="block text-sm font-medium text-gray-700 mb-1">
                    Status
                </label>
                <SamSelect
                    value={formData.statusDescription}
                    onChange={(e) => handleStatusChange(e)}
                    options={statuses}
                    placeholder="Select status"
                />
            </div>

            <textarea
                id="statusMessage"
                rows={5}
                required
                className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500"
                placeholder="Status message"
                value={formData.message}
                onChange={(e) => {
                    setFormData(prev => ({
                        ...prev,
                        message: e.target.value
                    }));
                }}
            />

            <div className="flex justify-end space-x-2">
                <CancelButton
                    type="button"
                    onClick={handleCancel}
                >
                    Cancel
                </CancelButton>
                <SamButton
                    type="submit"
                >
                    Update
                </SamButton>
            </div>
        </form>
    )
}